import { createReducer, on } from '@ngrx/store';
import * as PlatformDashboardActions from './platform-dashboard.actions';
import type { PlatformDashboardState } from './platform-dashboard.models';

export const initialState: PlatformDashboardState = {
  data: null,
  loading: false,
  error: null,
};

export const platformDashboardReducer = createReducer(
  initialState,
  on(PlatformDashboardActions.PlatformDashboardLoadRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PlatformDashboardActions.PlatformDashboardLoadSuccess, (state, { data }) => ({
    ...state,
    data,
    loading: false,
    error: null,
  })),
  on(PlatformDashboardActions.PlatformDashboardLoadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
